import type { IArticle } from '@bridebook/toolbox/src/types';
import { getArticlePath } from '@bridebook/web/lib/articles/constants/articleCategories';
import { getArticleThumbId } from './utils';
import type { IArticleCard } from './types';
import { format } from '@bridebook/web/lib/i18n/utils/get-date-fns-format';
import { DATE_FORMAT } from '@bridebook/web/lib/time-date-manipulation/time-date-manipulation';

export const toArticleCard = ({
  seo_title,
  title,
  slug,
  featured_image,
  terms,
  post_date,
  seo_metadesc,
}: IArticle): IArticleCard => {
  const category = (terms?.category || []).find(
    (c) => c.parent === 0 && !['locale', 'reading-list'].includes(c.slug),
  );

  return {
    title: seo_title || title,
    slug,
    articlePath: getArticlePath({ slug, terms }),
    img: getArticleThumbId(featured_image),
    tags: (terms?.post_tag ?? []).map(({ slug }) => slug),
    date: post_date ? format(new Date(post_date), DATE_FORMAT.DATE.MEDIUM) : undefined,
    description: seo_metadesc,
    categorySlug: category?.slug,
  };
};
